/* eslint-disable */
import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { isIE } from "react-device-detect";
import { Box, Typography, TextField, Button, Modal, Avatar } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import Footer from "../../../../layouts/Footer";
import Header from "../../../../layouts/Header";
import Layout from "../../../../layouts/Layout";
import Link from "../../../../shared/ui/Link";
import { UsePasswordResetRequest } from "../../shared/hooks/usePasswordResetRequest";
import { useAuth } from "../../shared/hooks/useAuth";
import { useAuthError } from "../../shared";
import { AuthError } from "../../shared";
import { passwordPatt, loginPatt } from "./constants/constants";
import messages from "./constants/messages";
import { State } from "./constants/types";
import { styles } from "./constants/styles";
import { RequestStatus } from "../../shared";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { PasswordField } from "../../../../shared/ui/PasswordField";
import { useUserSettings } from "../../../user/components/UserSettings/useUserSettings";
import ForgotPasswordForm from "./ForgotPasswordForm";
import { AVAILEBLE_EMAIL_DOMAINS } from "../RegisterPage/constants/constants";
import { browserHistory } from "../../../../routes/history";
import { passwordValidate } from "../../../../shared";

type Props = WithStyles<typeof styles>;

const AuthPage: React.FC<Props> = (props: Props) => {
  const [state, setState] = React.useState<State>({
    login: "",
    resetLogin: "",
    errors: {
      resetLogin: false,
      resetDomain: false,
      login: false,
      password: false,
      domain: false,
    },
    modalOpen: false,
  });
  const [requestStatus, passwordResetRequest] = UsePasswordResetRequest();
  const [isAuth, status, logIn] = useAuth();
  const { state: statePassword, changeField } = useUserSettings();
  const [errorCode, setErrorCode] = useAuthError();

  if (isAuth) {
    window.location.href = "/";
  }

  const handleChangeText = (id: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const textToApply = event.target.value.trim();
    setState({ ...state, [id]: textToApply });
  };

  const handleApply = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();
    setErrorCode(null);
    const isValid = checkValidity();

    if (isValid) {
      const { password } = statePassword;
      const { login: email } = state;
      logIn(email, password!);
    }
  };

  const checkValidity = () => {
    if (state.modalOpen) {
      let loginError = !state.resetLogin;
      if (!loginError) {
        const login = state.resetLogin.split("@")[0] || "";
        loginError = !login.match(loginPatt);
      }
      const domain = state.resetLogin.split("@")[1] || "";
      const domainError = !AVAILEBLE_EMAIL_DOMAINS.some((d) => d === domain);

      setState({ ...state, errors: { ...state.errors, resetLogin: loginError, resetDomain: domainError } });

      const errors = [loginError, domainError];
      return errors.every((error) => error === false);
    } else {
      let loginError = !state.login;
      if (!loginError) {
        const login = state.login.split("@")[0] || "";
        loginError = !login.match(loginPatt);
      }
      const domain = state.login.split("@")[1] || "";
      const domainError = !AVAILEBLE_EMAIL_DOMAINS.some((d) => d === domain);
      const passwordError = !statePassword.password; // || !!passwordValidate(statePassword.password, false).length;
      setState({
        ...state,
        errors: {
          ...state.errors,
          login: loginError,
          domain: domainError,
          password: passwordError,
        },
      });

      const errors = [loginError, domainError, passwordError];
      return errors.every((error) => error === false);
    }
  };

  const toggleModalOpen = () => {
    setState((prevState) => ({
      ...prevState,
      modalOpen: !prevState.modalOpen,
      errors: { login: false, password: false, resetLogin: false, domain: false, resetDomain: false },
    }));
  };

  const resetPassword = () => {
    const isValid = checkValidity();
    if (isValid) {
      const { resetLogin: email } = state;
      passwordResetRequest(email);
    }
  };

  const { classes } = props;
  const isPending = status === RequestStatus.Pending;
  return (
    <Layout>
      <Header />
      <div className={classes.root}>
        <Box className={classes.box}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            <FormattedMessage {...messages.header} />
          </Typography>
          <form noValidate className={classes.form}>
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              id="login"
              label={<FormattedMessage {...messages.login} />}
              name="login"
              autoComplete="login"
              value={state.login}
              onChange={handleChangeText("login")}
              InputLabelProps={{ classes: { root: classes.inputLabel }, shrink: isIE ? true : undefined }}
              error={state.errors.login || !!errorCode || state.errors.domain}
              InputProps={{
                classes: { input: classes.inputRoot },
              }}
              FormHelperTextProps={{ classes: { root: classes.helperText } }}
              classes={{ root: classes.textField }}
              helperText={
                (state.errors.login || state.errors.domain || (!!errorCode && errorCode === AuthError.BadRequest)) && (
                  <FormattedMessage {...messages.errorMessage} />
                )
              }
            />
            <PasswordField
              InputLabelProps={{ classes: { root: classes.inputLabel }, shrink: isIE ? true : undefined }}
              variant="outlined"
              margin="normal"
              fullWidth
              value={statePassword.password}
              onChange={({ target }) => changeField("password", target.value)}
              customErrorState={state.errors["password"] || !!errorCode}
              isHaveTooltip={false}
              isHaveValidateText={false}
              customLabel={messages.password}
              inputProps={{ classes: { input: classes.inputRoot } }}
              customHelperText={
                state.errors.password || !!errorCode ? <FormattedMessage {...messages.errorMessage} /> : undefined
              }
              useMatch={false}
            />
            <div className={classes.buttonBase}>
              <Button
                type="submit"
                className={classes.loginButton}
                variant="contained"
                color="primary"
                onClick={handleApply}
                disabled={isPending}
              >
                <FormattedMessage {...messages.loginButton} />
              </Button>

              <Link className={classes.link} active={true} to={`/login/sign-up`}>
                <Button className={classes.authButton} variant="contained" color="secondary" disabled={isPending}>
                  <FormattedMessage {...messages.register} />
                </Button>
              </Link>
            </div>
            <div className={classes.footer}>
              <Button className={classes.footerButton} onClick={toggleModalOpen} disabled={isPending}>
                <FormattedMessage {...messages.forgotPassword} />
              </Button>
              <Modal open={state.modalOpen} onClose={toggleModalOpen}>
                <ForgotPasswordForm
                  stateAuth={state}
                  errorStatus={errorCode}
                  requestStatus={requestStatus}
                  resetPassword={resetPassword}
                  handleChangeText={handleChangeText}
                />
              </Modal>
            </div>
          </form>
        </Box>
      </div>
      <Footer />
    </Layout>
  );
};

export default withStyles(styles)(AuthPage);
